import styled from "styled-components";
import { Row } from "../../../components/flex/styled";

export const HowWouldYouLikeToUseWrapper = styled(Row)(() => {
  return {
    // Mirabel, your CSS should go under here
    gap: 0,
    justifyContent: "space-between",
    minHeight: "100vh",
    ".image-page, .basebutton-page": {
      flex: 1,
    },

    ".image-page": {
      padding: "calc(var(--cardPadding) * 2)",
      backgroundColor: "#286c2b",
      color: "white",
    },

    ".image-page>svg": {
      width: "100%",
      height: "auto",
    },

    ".basebutton-page": {
      padding: "calc(var(--cardPadding) * 2)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      " & p": {
        color: "var(--color-text)",
        fontSize: "1.2rem",
      },
    },

    ".basebutton": {
      gap: "calc(var(--flexGap))",
      overflow: "hidden",
    },

    ".basebutton button": {
      padding: "calc(var(--cardPadding) / 2.5) calc(var(--cardPadding) / 2)",
    },

    "& .logo-box-area": {
      marginBlockEnd: "calc(var(--cardPadding)/1)",
    },

    "@media screen and (max-width: 1280px)": {
      ".image-page, .basebutton-page": {
        padding: "calc(var(--cardPadding) * 2)",
      },
    },

    "@media screen and (max-width: 1024px)": {
      ".basebutton": {
        gap: "var(--flexGap)",
      },
      "& .logo-box-area": {
        maxWidth: "50%",
        marginBlockEnd: 0,
        "& svg": {
          width: "100%",
          height: "auto",
        },
      },
    },

    "@media screen and (max-width: 768px)": {
      ".image-page, .basebutton-page": {
        padding: "calc(var(--cardPadding) * 1.5)",
      },
    },

    "@media screen and (max-width: 425px)": {
      ".image-page, .basebutton-page": {
        padding: "calc(var(--cardPadding))",
      },
    },
  };
});
